<template>
  <div id="select-month-filed" class="aisea-text-16-400-black">
    <!-- <v-select
      name="target_year_month"
      placeholder="年月を選択"
      :value="selectedYearMonth"
      :clearable="false"
      :options="yearMonthList"
      label="label"
      :disabled="yearMonthList.length === 0"
      @input="handleChange"
      style="min-width: 133px"
    >
      <template v-slot:no-options>-</template>
    </v-select> -->
    <!-- <treeselect
        placeholder="月のプルダウン"
        class="aaaaa"
      ></treeselect> -->
    <treeselect
      v-model="selectedMonth"
      :options="monthOptions"
      :multiple="false"
      :clearable="false"
      placeholder="あ月"
      noOptionsText="なし"
      class="mr-4 my-1"
      @input="onFilterChanged"
      noResultsText="見つかりませんでした"
    ></treeselect>
  </div>
</template>


<script>
//   import vSelect from "vue-select";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const MONTHS = [
  "1月",
  "2月",
  "3月",
  "4月",
  "5月",
  "6月",
  "7月",
  "8月",
  "9月",
  "10月",
  "11月",
  "12月",
];

export default {
  name: "SelectMonthField",
  mixins: [],
  components: {
    //   vSelect,
      Treeselect,
  },
  props: {
    // selectedYearMonth: { Type: Object, default: () => null },
    // yearMonthList: { Type: Array, default: [] },
    // changeSelectedYearMonth: { Type: Function, default: () => {} },
  },
  data() {
    return {
      selectedMonth: 6,
      monthOptions: MONTHS.map((month, index) => {
        return {
          id: index + 1,
          label: month,
        };
      }),
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleChange(nextYearMonth) {
      // this.changeSelectedYearMonth(nextYearMonth);
      console.log("handleChange");
    },
    onFilterChanged() {
      console.log("onFilterChanged()");
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#select-month-filed {
  display: flex;
  --vs-dropdown-min-width: 133px;
  .vs__dropdown-menu {
    max-height: 200px;
  }
}
</style>
